import {Component} from 'react';
import "./Admin/admin.css";
import { editEventCondition } from './editEventConditionProcesses/editEventCondition';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import PlayerCommentActionRequiredModal from './player_comment_action_reqd_modal';
import LoanAndPMICalculatorModal from './loan_and_PMI_calculator_modal';
import JobListModal from './job_list_modal';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import ExportToExcelButton from './export_to_excel';
import SelectSkipConditionCheckModal from './select_skip_condition_check_modal';
import ReportParmInputModal from './report_parm_input_modal';
import GenericModal from './generic_modal';
import BackEndLogReport from './back_end_log_report';
import rptJobSkillsList from './objects/rpt_job_skills_list';


class OtherReports extends Component {
    constructor(props) {
        super(props);
        this.adminInfo = this.props.adminInfo();
        this.state={
          headers: setHeadersForFetch(),  
          loadActionRequired: false,
          openPMICalculator: false,
          loadJobListData: false,
          subProcess: "OtherReports",
          environment: Config.dataURL.currentEnv,
          exportToExcelButton: false,
          eventsForCondition: false,
          graphPriceData: false,
          loadBackEndLogData: false,
          openBackEndLogReport: false,
        };   
        this.waitState=false;
        this.jobList = null;
        this.reviewCodeArr = [0,3,4,5,6,7,8]
    }

    editEventConditions(){
        var i;
        var errorArray=[];
        this.reportDataArr=[];
        let headerLine = {condName: "Condition Name", rcdNbr: "Record Number", triggeredBy: "Triggered By",
            fieldName: "Field Name", fieldValue: "FieldValue", errorMsg: "Error Message"};
        this.reportDataArr.push(headerLine);
        this.eventSelectAndTriggerConditions();
        for(i=0; i<this.adminInfo.conditionsData.length; i++){
            errorArray=editEventCondition(this.adminInfo.conditionsData[i], this.selectConditions, this.triggerConditions);
            for (let j=0; j<errorArray.length; j++){
                let reportLine = {condName: this.adminInfo.conditionsData[i].condName, rcdNbr: i + 1,
                      triggeredBy: this.adminInfo.conditionsData[i].triggeredBy, fieldName: errorArray[j].fieldName,
                      fieldValue: errorArray[j].fieldValue, errorMsg: errorArray[j].message};
                this.reportDataArr.push(reportLine);
                    
            }
            errorArray = [];
        }
        this.rptTitle = "Conditions Edit Report";
        this.rptLines = this.reportDataArr;
        this.exportReportsDataset();
    }

    eventSelectAndTriggerConditions(){
        this.selectConditions = [];
        this.triggerConditions = [];
        for (let i=0; i<this.adminInfo.eventsData.length; i++){
             let eventsData = this.adminInfo.eventsData[i];
             if (eventsData.conditionArr ){
                let conditionList = eventsData.conditionArr;
                for (let j=0; j<conditionList.length; j++ ){
                    this.selectConditions.push(conditionList[j]);
                }
             }
             if (eventsData.skipConditionArr ){
                let skipConditionList = eventsData.skipConditionArr;
                for (let j=0; j<skipConditionList.length; j++){
                    this.selectConditions.push(skipConditionList[j])
                }
             }
             for (let j=0; j<eventsData.responses.length; j++){
                let response = eventsData.responses[j];
                for (let k=0; k<response.possibleEffects.length; k++){
                    let possibleEffects = response.possibleEffects[k];
                    if (possibleEffects.triggerCondition ){
                        this.triggerConditions.push(possibleEffects.triggerCondition);
                    }
                }
             }
        }
    }

    conditionsList(){
        var i;
        this.conditionListArr=[];
        var conditionObj="";
        for (i=0; i < this.adminInfo.conditionsData.length; i++){
            if (i===0){
                this.conditionsListHeader();
            }
            this.conditionNbr = i + 1;
            conditionObj = this.adminInfo.conditionsData[i];
            this.buildConditionsListArr(conditionObj);
        }
        this.rptTitle = "Conditions List";
        this.rptLines =  this.conditionListArr;
        this.exportReportsDataset();
    }

    conditionsListHeader(){
        let conditionString = {condNbr: "Condition Nbr", condName: "Condition Name", condClass: "Condition Class",
            primaryField: "Primary Field Name", relationType: "Relation Type", compareValues: "Compare Values",
            triggeredBy: "Triggered By"};
        this.conditionListArr.push(conditionString);
    }

    buildConditionsListArr(conditionObj){
        let compareValues = conditionObj.compareValues.join();
        let conditionString = {condNbr: this.conditionNbr, condName: conditionObj.condName, 
            condClass: conditionObj.conditionClass, primaryField: conditionObj.primaryFieldName,
            relationType: conditionObj.relationType, compareValues: compareValues,
            triggeredBy: conditionObj.triggeredBy};
        this.conditionListArr.push(conditionString);
    }

    rebuildJobConditionsList(){
        //   I believe after the xcel is created you can just upload to MongoDB via the mongoose tool
        this.jobConditionsArr = [];
        var conditionObj = "";
        this.jobOptionsArr = [];
        for (let i=0; i< this.jobList.length; i++){
            if (this.jobList[i].jobName !== "Template"){
                let jobName = this.jobList[i].jobName;
                let condNamelc = (jobName.toLowerCase());
                let condName = condNamelc.split(" ").join("-"); 
                conditionObj = {
                        condName: condName,
                        conditionClass: "job",
                        primaryFieldName: "careerID",
                        relationType: "EQ",
                        compareValues: "[" + this.jobList[i].id + "]",
                        triggeredBy:  "jobChange"
                        }
                this.jobConditionsArr.push(conditionObj);
            }
        }
        this.rptTitle = "Job Conditions";
        this.rptLines = this.jobConditionsArr;
        this.exportReportsDataset();
    }

    buildJobSkillsRpt(){
         let jobSkillsArr = rptJobSkillsList(this.jobList, this.skillsList);
         this.rptTitle = "Job Skills List";
         this.rptLines = jobSkillsArr;
         this.waitState = false;
         this.exportReportsDataset();
    }

    openReportModal(reportType){
        this.openModal = true;
        this.waitState = true;
        this.reportType = reportType;
        this.setState({exportToExcelButton: false});
        switch (reportType){
            case "ActionRequired":
                this.loadPlayerFeedback(reportType);
                break;
            case "jobList":
                this.loadJobList(reportType);
                break;
            case "eventsForCondition":
                this.setState({eventsForCondition: true});
                break;
            case "openPMICalculator":
                this.setState({openPMICalculator: true});
                break;
            case "rebuildJobConditionsList":
                this.loadJobList(reportType);
                break;
            case "graphInvestPrices":
                this.waitState = false;
                this.setState({getReportParms: true});
                break;
            case "backEndLog":
                if (this.state.loadBackEndLogReport === true){
                    this.setState({openBackEndLogReport: true})
                }else{
                    this.loadBackEndLog();
                }
                break;
            case "jobSkillsList":
                this.waitSate = true;
                this.loadJobList(reportType);
                break;
            default:
                break;
        }
    }

    closeReportModal(modalType){
        this.openModal = false;
        switch (modalType){
            case "actionRequired":
                this.setState({loadActionRequired: false});
                break;
            case "jobList":
                this.setState({loadJobListData: false});
                break;
            case "eventsForCondition":
                this.setState({eventsForCondition: false});
                break;
            case "openPMICalculator":
                this.setState({openPMICalculator: false});
                break;
            case "reportParmInput":
                this.setState({getReportParms: false});
                break;
            case "graphPriceData":
                this.setState({graphPriceData: false });
                break;
             case "backEndLogReport":
                this.setState({openBackEndLogReport: false });
                break;
            case "jobSkillsList":
                this.setState({loadJobListData: false});
                break;
            default:
                break;
        }
        this.waitState = false;
    }
     
    exportReportsDataset() {
        this.setState({exportToExcelButton: true});    
    }

    removeExportButton(){
        this.setState({exportToExcelButton: false});
    }

    setupPriceGraph(returnObj){
        this.modalName = "displayGraph";
        this.modalTitle = "Display Price Graph";
        this.dataObj = {...returnObj, firstMonthDate: "2025-08", buyDates: []}
        this.setState({getReportParms: false, graphPriceData: true});
    }
            
    render() {
             
    return <>
           <div className="col-sm-6 mb-5 input-page-base-card">
                <div className="card mt-3 mr-5 rounded-corners-lg height-max">
                    <h1 className="mt-3 p-0 text-center">Game Administration</h1>
                    <h4 className="text-center">Event Condition and Other Reports</h4>
                    <table className="row-100  ml-2 mt-3 overflow-scroll">
                        <tbody className="w-40">
                            <tr>
                                <td className = "col-sm-6 text-center">  
                                    <button className="btn-group-wide" 
                                        onClick ={()=> this.editEventConditions()}>
                                           Edit Event Conditions
                                    </button>
                                </td>
                                <td className="col-sm-6 text-center">
                                    <button className="btn-group-wide mt-2" 
                                        onClick ={()=> this.conditionsList()}>
                                         Conditions List 
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td className="col-sm-6 text-center">
                                    <button className="btn-group-wide mt-2" 
                                        onClick ={()=> this.openReportModal("ActionRequired")}>
                                            Action Required
                                    </button>
                                </td>
                                 <td className="col-sm-6 text-center">
                                    <button className="btn-group-wide mt-2" 
                                         onClick ={()=> this.openReportModal("jobList")}>
                                           Job List
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td className="col-sm-6 text-center">
                                    <button className="btn-group-wide mt-2"
                                     onClick ={()=> this.openReportModal("eventsForCondition")} >
                                        Events For Specified Condition
                                    </button>
                                </td>
                                <td className="col-sm-6 text-center">
                                    <button className="btn-group-wide mt-2" 
                                        onClick ={()=> this.openReportModal("openPMICalculator")}>
                                            Loan and PMI Calculator
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td className="col-sm-6 text-center">
                                    <button className="btn-group-wide mt-2" 
                                        onClick ={()=> this.openReportModal("rebuildJobConditionsList")}>
                                             Rebuild Job Condition Dataset
                                    </button>
                                </td>
                                <td className="col-sm-6 text-center" >
                                    <button className="btn-group-wide mt-2" 
                                      onClick ={()=> this.openReportModal("graphInvestPrices")}>
                                            Graph Investment Prices
                                    </button>
                                </td>
                            </tr>
                             <tr>
                                <td className="col-sm-6 text-center">
                                    <button className="btn-group-wide mt-2" 
                                        onClick ={()=> this.openReportModal("backEndLog")}>
                                            Back End Log Report
                                    </button>
                                </td>
                                <td className="col-sm-6 text-center" >
                                    <button className="btn-group-wide mt-2" 
                                      onClick ={()=> this.openReportModal("jobSkillsList")}>
                                            Job Skills List
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div>

                    {this.waitState ?
                      <div className="text-center mt-3">
                            <WaitTimeSpinner/>
                            <div className="mt-3 text-white">testing</div>
                            <h3 className="mt-2">This may take a few minutes to load.</h3>
                        </div>
                    :
                        null
                    }

                    {this.state.loadActionRequired ?
                        <PlayerCommentActionRequiredModal openModal={this.openModal} 
                            onClose={() => this.closeReportModal("actionRequired")} 
                            commentsOnly={false}
                            playerFeedback={this.playerFeedback}
                            reviewCodeArr={this.reviewCodeArr}                            
                        />
                    :
                        null
                    }

                    {this.state.getReportParms ?
                        <ReportParmInputModal   openModal={this.openModal}
                            parmName={"selectInvestment"}
                            onClose={() => this.closeReportModal("reportParmInput")} 
                            parmsComplete={(returnObj) => this.setupPriceGraph(returnObj)} 
                        />
                    :
                        null
                    }

                    {this.state.openPMICalculator  ?
                         <LoanAndPMICalculatorModal openModal={this.openModal} 
                            onClose={() => this.closeReportModal("openPMICalculator")} 
                          
                       />
                    :
                        null
                    }

                    {this.state.loadJobListData && this.reportType === "jobList" ?
                        <JobListModal
                            openModal={this.openModal}
                            jobListArr={this.jobList}
                            onClose={() => this.closeReportModal("jobList")} 
                        />
                    :
                        null
                    }
              
                    {this.state.eventsForCondition ?
                        <SelectSkipConditionCheckModal
                            openModal={this.openModal}
                            eventsData={this.adminInfo.eventsData}
                            onClose={() => this.closeReportModal("eventsForCondition")} 
                        />
                    :
                        null
                    }

                    {this.state.graphPriceData ?
                        <GenericModal
                            openModal={this.openModal}
                            modalName = {this.modalName}
                            modalTitle = {this.modalTitle}
                            dataObj = {this.dataObj}
                            processError = {(errorObj) => this.props.processError(errorObj)}
                            onClose={() => this.closeReportModal("graphPriceData")} 
                        />
                    :
                        null
                    }
                                                         
                    </div>

                    {this.state.openBackEndLogReport ?
                        <BackEndLogReport
                            show={this.state.openBackEndLogReport}
                            backEndLogData={this.backEndLogData}
                            onClose={() => this.closeReportModal("backEndLogReport")} 
                        />
                    :
                        null
                    }

                    {this.state.exportToExcelButton ?
                        <ExportToExcelButton
                            fileName={this.rptTitle}
                            rptHeader={this.rptHeader}
                            data={this.rptLines}
                            exportComplete={() => this.removeExportButton()}
                        />
                    :
                        null
                    }

                   
                </div>        
            </div>
        </>
    }


loadPlayerFeedback(reportName){
    const funcName = "loadPlayerFeedback";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
       {method:'GET', headers: this.state.headers})
       .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.sortPlayerFeedback(output.body, reportName);
                    this.setState({loadActionRequired: true});
                    this.waitState = false;
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
    });
}

sortPlayerFeedback(playerFeedback, reportName){
    this.playerFeedback = [];
    for (let i=0; i<playerFeedback.length; i++){
        let sortKey = "";
        if (reportName === "Player"){
            sortKey = playerFeedback[i].user + playerFeedback[i].dateAdded + playerFeedback[i].timeAdded;
        }else{
            if (!playerFeedback[i].reviewed){
                playerFeedback[i] = {...playerFeedback[i], reviewed: {code: 0, dateAdded: 12/31/99}};
            }
            sortKey = playerFeedback[i].reviewed.code + playerFeedback[i].dateAdded +
                playerFeedback[i].timeAdded;
        }
        let feedbackObj = {...playerFeedback[i], sortKey: sortKey};
        this.playerFeedback.push(feedbackObj);
    }
    (this.playerFeedback).sort((a, b) => (a.sortKey > b.sortKey) ? 1 : -1)
}

  loadJobList(rptType){
    this.setState({waitState: true});
    const funcName = "jobListAll";
    const urlParm = ""; 
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.jobList = output.body;
                        this.waitState = false;
                        switch (rptType){
                            case "jobList":
                                this.jobList = 
                                    this.jobList.sort((a, b) => (a.jobName > b.jobName) ? 1 : -1);
                                this.setState({loadJobListData: true});
                                break;
                            case "rebuildJobConditionsList":
                                this.rebuildJobConditionsList();
                                break;
                            case "jobSkillsList":
                                this.jobList = 
                                    this.jobList.sort((a, b) => (a.jobName > b.jobName) ? 1 : -1);
                                this.getSkillsList();
                                break;
                            default:
                                break;
                        }
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
  }

  getSkillsList() {
      let headers = setHeadersForFetch();
      const funcName = "skillsQuestions";
      const urlParm = "";
      const uri = buildUrl(this.state.environment, funcName, urlParm);
      fetch (uri,  
          {method:'GET',
           headers: headers
          })
          .then(response => {
              if (response.ok){
                  response.json().then(data => {
                      const output = JSON.parse(data);
                      const statusCode = output.statusCode;
                      if (statusCode === 200){
                          this.skillsList = output.body;
                          this.skillsList = 
                                this.skillsList.sort((a, b) => (a.questionNbr > b.questionNbr) ? 1 : -1);
                          this.buildJobSkillsRpt();
                      }else{
                          const errorObj={function: funcName, subProcess: this.state.subProcess, 
                              status: statusCode, message: output.body.message};
                          this.props.processError(errorObj);
                      }
                  });
              };
      });
  }
  
  loadBackEndLog(){
    this.setState({waitState: true});
    const funcName = "backEndLogList";
    const urlParm = ""; 
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.waitState = false;
                        this.backEndLogData = output.body.sort((a, b) => {
                            if (a.gameID !== b.gameID) return a.gameID > b.gameID ? 1 : -1;
                            if (a.dateAdded !== b.dateAdded) return a.dateAdded > b.dateAdded ? 1 : -1;
                            if (a.timeAdded !== b.timeAdded) return a.timeAdded > b.timeAdded ? 1 : -1;
                            return (+a.sequenceNbr) - (+b.sequenceNbr);
                        });
                        this.setState({loadbackEndLogData: true, openBackEndLogReport: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
  }
     

}

export default OtherReports;